import { Routes } from '@angular/router';
import { SigninManager } from 'sham-components/shared/auth';
import { CustomerSupportSigninManager } from './services/signin-manager.service';
import { dashboardGuestGuard, dashboardRoleGuard } from 'sham-components/services';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [dashboardGuestGuard('CustomerSupportAdmin', ['/app'])],
    loadComponent: () =>
      import('./features/auth/signin/signin').then((x) => x.Signin),
    providers: [{ provide: SigninManager, useClass: CustomerSupportSigninManager }],
  },
  { path: 'signin', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'reset-password/:token',
    loadComponent: () =>
      import('./features/reset-password/reset-password').then(
        (x) => x.ResetPasswordComponent,
      ),
  },
  {
    path: 'app',
    canActivate: [dashboardRoleGuard('CustomerSupportAdmin', ['/login'])],
    canActivateChild: [dashboardRoleGuard('CustomerSupportAdmin', ['/login'])],
    loadComponent: () =>
      import('./layouts/dashboard/dashboard').then((x) => x.Dashboard),
    loadChildren: () => import('./shared/dashboard-routes'),
  },

  { pathMatch: 'full', path: '', redirectTo: '/login' },
  { path: '**', redirectTo: '/login' },
];
